import React, {Component} from 'react';
import {Route, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import LoadingOverlay from '../../shared/components/LoadingOverlay';
import commonActionCreators from '../../shared/store/common/action-creators';
import {Auth} from "../services/aws";
import departmentSettingsActionsCreators from "../../subscriber-app/store/department-settings/action-creators";
import {clearSharedStorage, updateSharedStorage} from "../services/shared-storage";

// import rootActionCreators from '../store/action-creators';

class AuthenticatedRoute extends Component {
  constructor(props) {
    super(props);
    const inheritedProps = { ...props };
    delete inheritedProps.allow;
    delete inheritedProps.component;
    delete inheritedProps.deny;
    this.state = { inheritedProps };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    // TODO Promise resolves to boolean, so trigger overlay to hide UI bounce if necessary
    this.getSessionStatus()
      .then(() => {
        return true;
      })
      .catch((error) => {
        return this.handleSessionStatusError(error.message);
      });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.isRedirecting && (nextProps.path !== this.props.path)) {
      // TODO Promise resolves to boolean, so trigger overlay to hide UI bounce if necessary
      this.getSessionStatus()
        .then(() => {
          return true;
        })
        .catch((error) => {
          return this.handleSessionStatusError(error.message);
        });
    }
    if (nextProps.path === this.props.redirectingTo) {
      this.props.setRedirectingTo(null);
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  get isRedirecting() {
    return !!this.props.isRedirectingTo;
  }

  get loginWithCurrentPath() {
    return `/login?redirect=${this.props.location.pathname}${
      this.props.location.search
    }`;
  }

  // ----------------------
  // Methods
  // ----------------------

  getCurrentUserToken() {
    return Auth.currentSession()
      .then(res => res.accessToken.jwtToken)
  }

  getUserContext(currentUserToken) {
    if (!currentUserToken) {
      return Promise.resolve(null);
    }
    if (this.props.userContext.isAuthenticated) {
      return Promise.resolve(this.props.userContext);
    }
    this.props.fetchDepartmentSettings();
    return this.props.fetchUserContext(currentUserToken)
      .then(res => {
        return Promise.all([
          res,
          updateSharedStorage()
        ])
      })
      .then(([res]) => res)
  }

  //  This is a fallback for the setup that typically happens on successful login. Repopulates
  //    the Redux store in the case of User navigating directly to an application route.
  //
  //    1. Attempt to restore authentication by getting the current User token from local storage
  //    2. Attempt to restore authorization by getting the userContext
  getSessionStatus() {
    return new Promise(async (resolve, reject) => {
      const currentUserToken = await this.getCurrentUserToken();
      const userContext = await this.getUserContext(currentUserToken);
      this.props.setUserContext(userContext);
      if (!currentUserToken) {
        return reject(new Error('NOT_AUTHENTICATED'));
      }
      if (!userContext) {
        return reject(new Error('NOT_AUTHORIZED'));
      }
      if (this.shouldRedirect(userContext)) {
        return reject(new Error('FORBIDDEN'));
      }
      return resolve('IS_VALID');
    });
  }

  handleSessionStatusError(message) {
    switch (message) {
      case 'NOT_AUTHENTICATED':
      case 'NOT_AUTHORIZED':
        this.redirectTo(this.loginWithCurrentPath);
        return false;
      case 'FORBIDDEN':
        this.redirectTo('/forbidden');
        return false;
      default:
        return false;
    }
  }

  isAllowed(userContext) {
    return this.props.allow.includes(userContext.scope);
  }

  isDenied(userContext) {
    return this.props.deny.includes(userContext.scope);
  }

  redirectTo(path) {
    this.props.setRedirectingTo(path);
    this.props.history.push(path);
  }

  resetUserSession() {
    Auth.signOut();
    // this.props.resetUserSession();
    clearSharedStorage()
      .then(() => {
        this.props.history.push(this.loginWithCurrentPath);
      })

  }

  shouldRedirect(userContext) {
    return (
      (!!this.props.deny && this.isDenied(userContext)) ||
      (!!this.props.allow && !this.isAllowed(userContext))
    );
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={!this.props.userContext.isAuthenticated}>
        {this.props.userContext.isAuthenticated &&
          <Route
            render={() => (
              <this.props.component {...this.state.inheritedProps} />
            )}
          />
        }
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux/Router Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    redirectingTo: state.common.redirectingTo,
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserContext: (userGuid) => {
      return dispatch(commonActionCreators.fetchUserContext(userGuid));
    },
    // resetUserSession: () => {
    //   return dispatch(rootActionCreators.resetRootState());
    // },
    fetchDepartmentSettings: () => {
      dispatch(departmentSettingsActionsCreators.fetchDepartmentSettings());
    },
    setRedirectingTo: (redirectingTo) => {
      return dispatch(commonActionCreators.setRedirectingTo(redirectingTo));
    },
    setUserContext: (userContext) => {
      return dispatch(commonActionCreators.setUserContext(userContext));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute));
